var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "684px",
      "persistent": ""
    },
    model: {
      value: _vm.displayConfirmationModal,
      callback: function ($$v) {
        _vm.displayConfirmationModal = $$v;
      },
      expression: "displayConfirmationModal"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm.isDisabling ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(" " + _vm._s(_vm.$t('amazon_transparency_disable')) + " ")]) : _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(" " + _vm._s(_vm.$t('amazon_transparency_enable')) + " ")]), _c('span', {
    staticClass: "text-lowercase"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_auto_upload')))])])]), _c('div', {
    staticClass: "ma-5"
  }, [_vm.isDisabling ? _c('div', [_c('span', {
    staticClass: "modal-desc-text"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_existing_uploaded')))]), _c('br'), _c('span', [_vm._v(_vm._s(_vm.$t('amazon_transparency_after_disabling')))])]) : _c('div', [_c('span', {
    staticClass: "modal-desc-text"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_please_confirm')))]), _c('br'), _c('span', [_vm._v(_vm._s(_vm.$t('amazon_transparency_enable_qr_upload')))])])]), _c('v-card-actions', {
    staticClass: "pa-4 px-8 mt-3 pb-6"
  }, [_c('v-spacer'), _c('v-btn', {
    staticClass: "text-uppercase",
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.handleCancelBtn
    }
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_cancel')))]), _vm.isDisabling ? _c('v-btn', {
    staticClass: "text-uppercase",
    attrs: {
      "color": "red",
      "text": ""
    },
    on: {
      "click": _vm.handleDisableBtn
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('amazon_transparency_disable')) + " ")]) : _c('v-btn', {
    staticClass: "text-uppercase",
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.handleEnableBtn
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('amazon_transparency_enable')) + " ")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }